import { merchantApi } from '@/config/axios'

// ========== 商家端角色管理 API ==========

export const getRolePage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/member/role/page', params })
}

export const getRole = (id: number) => {
  return merchantApi.get({ url: `/merchant-api/member/role/get?id=${id}` })
}

export const createRole = (data: any) => {
  return merchantApi.post({ url: '/merchant-api/member/role/create', data })
}

export const updateRole = (data: any) => {
  return merchantApi.put({ url: '/merchant-api/member/role/update', data })
}

export const deleteRole = (id: number) => {
  return merchantApi.delete({ url: `/merchant-api/member/role/delete?id=${id}` })
}

export const getPermissionList = () => {
  return merchantApi.get({ url: '/merchant-api/member/role/permission/list' })
}

export const getRoleList = () => {
  return merchantApi.get({ url: '/merchant-api/member/role/list' })
}
